import { ImmersiveLine } from 'Components/lines/immersive-line/ImmersiveLine';
export default ImmersiveLine;
